const binding = { modules: {}, dataActions: {} };

    (binding.modules['dynamic-image-carousel'] = {
        c: () => require('partner/modules/dynamic-image-carousel/dynamic-image-carousel.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'dynamic-image-carousel',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/dynamic-image-carousel'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|dynamic-image-carousel|dynamic-image-carousel'] = {
                c: () => require('partner/modules/dynamic-image-carousel/dynamic-image-carousel.view.tsx'),
                cn: '__local__-__local__-dynamic-image-carousel'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };